import { type ReactNode } from 'react'
import { cn } from '../lib/utils'
import type { Group } from '../types'

// Group row with the group cover as a darkened background (falls back to a card
// surface when there's no cover). Used by the suggest-event, schedule-share and
// totem group pickers.
// `trailing` receives hasImage so it can style for the cover (white) vs plain
// (muted) variant.
export function GroupRow({
  group,
  onClick,
  trailing,
  selected,
  ariaPressed,
}: {
  group: Group
  onClick: () => void
  trailing?: (hasImage: boolean) => ReactNode
  selected?: boolean
  ariaPressed?: boolean
}) {
  const hasImage = !!group.imageUrl
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={ariaPressed}
      className={cn(
        'relative w-full flex items-center justify-between gap-3 rounded-lg overflow-hidden border px-4 py-3 transition-colors cursor-pointer text-left',
        hasImage
          ? 'border-primary/25 hover:border-primary/40'
          : 'border-border bg-card hover:bg-muted/40',
        selected && 'border-primary',
      )}
      style={
        hasImage
          ? {
              backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${group.imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }
          : undefined
      }
    >
      <span className={cn('text-sm font-medium truncate', hasImage && 'text-on-image')}>
        {group.name}
      </span>
      {trailing?.(hasImage)}
    </button>
  )
}
